import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { getRequest } from "services/api/apiService";

// Bandeau réutilisable "connecter une plateforme", affiché en tête des modules
// Ads / Tracking / Stratégie / Cinema. Se masque tout seul si au moins une
// plateforme (ou celles requises) est connectée.
//
// Props :
//   required  : liste de plateformes attendues (ex: ["meta","tiktok"]) ; si
//               omis, n'importe quelle connexion suffit.
//   moduleLabel, accent : personnalisation visuelle par module.
const ConnectPlatformBanner = ({ required = null, moduleLabel = "ce module", accent = "indigo" }) => {
  const [connected, setConnected] = useState(null); // null = en cours

  useEffect(() => {
    getRequest("/api/connected-platforms/all")
      .then((res) => {
        // La réponse peut être un tableau ou un objet {platform: bool}.
        const names = Array.isArray(res)
          ? res.map((p) => (p.name || p.platform || "").toLowerCase()).filter(Boolean)
          : Object.entries(res || {}).filter(([, v]) => v).map(([k]) => k.toLowerCase());
        setConnected(names);
      })
      .catch(() => setConnected([]));
  }, []);

  if (connected === null) return null; // ne rien clignoter pendant le chargement

  const missing = required
    ? required.filter((r) => !connected.includes(r.toLowerCase()))
    : (connected.length === 0 ? ["une plateforme"] : []);

  if (missing.length === 0) return null; // tout est connecté → pas de bandeau

  const C = {
    indigo: "from-indigo-50 to-white border-indigo-200 text-indigo-700",
    blue: "from-blue-50 to-white border-blue-200 text-blue-700",
    emerald: "from-emerald-50 to-white border-emerald-200 text-emerald-700",
    amber: "from-amber-50 to-white border-amber-200 text-amber-700",
    fuchsia: "from-fuchsia-50 to-white border-fuchsia-200 text-fuchsia-700",
  }[accent] || "from-indigo-50 to-white border-indigo-200 text-indigo-700";

  return (
    <div className={`bg-gradient-to-r ${C} border rounded-2xl p-4 mb-5 flex items-center justify-between gap-4 flex-wrap`}>
      <div className="flex items-start gap-3">
        <FontAwesomeIcon icon={faLink} className="mt-1" />
        <div>
          <p className="font-semibold text-[#221C51] text-sm">
            Connectez {required ? `${missing.join(", ")}` : "une plateforme"} pour utiliser {moduleLabel}
          </p>
          <p className="text-xs text-gray-500 mt-0.5">
            Reliez vos comptes publicitaires pour lancer, suivre et optimiser vos campagnes.
          </p>
        </div>
      </div>
      <Link
        to="/dashboard/connected-platforms"
        className="shrink-0 px-4 py-2 bg-[#221C51] text-white text-sm font-semibold rounded-xl hover:bg-[#2e265e] flex items-center gap-2"
      >
        <FontAwesomeIcon icon={faCircleCheck} className="text-xs" />
        Connecter une plateforme
      </Link>
    </div>
  );
};

export default ConnectPlatformBanner;
